import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RedirectToHome from '../../components/RedirectToHome';
import { routes } from './routes';
import { TableSortProvider } from '../../../../context/TableSortingContext';
import { SupportHeader } from './components/PageHeader';

type Props = {
  isManager?: boolean;
};

const Content: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Switch>
    {Object.values(routes()).map(({ render, route }, i) => (
      <Route
        key={i}
        exact={true}
        path={route.template()}
        render={() => render()}
      />
    ))}
    <Route path="*">
      <RedirectToHome />
    </Route>
  </Switch>
);

export const SupportPage: React.FC<React.PropsWithChildren<Props>> = ({
  isManager = false,
}) => {
  return (
    <div className="position-relative">
      <SupportHeader isManager={isManager} />
      <TableSortProvider storeAgeKey="tickets">
        <Content />
      </TableSortProvider>
    </div>
  );
};
